module.exports = __webpack_public_path__ + "static/euan-ashley-35313601f7b13947cecec7b9f0339af7.png";